// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"718":"design-project","810":"production-order"}[chunkId] + "." + {"718":"5a5e175f","810":"9c6b5c78"}[chunkId] + ".css";
};